import { Injectable } from "@angular/core";
import * as moment from "moment";

interface RecurrenceRendezVous {
  dateDebutInitiale: Date;
  dateFinInitiale: Date;
  delais: number;
  uniteDeTemps: UniteDeTempsEnum;
  parametresSemaine?: ParametresSemaine;
  finRecurrence: FinRecurrence;
}

export enum UniteDeTempsEnum {
  Week = "week",
  Month = "month",
  Year = "year",
}

interface ParametresSemaine {
  uniteSemaineJoursDeLaSemaine: number[];
}

interface FinRecurrence {
  type: FinRecurrenceTypeEnum
  date?: Date;
  nombreOccurrence?: number;
}

export enum FinRecurrenceTypeEnum {
  Date = "date",
  OcurrenceNumber = "ocurrenceNumber",
}



@Injectable({
  providedIn: 'root'
})
export class RecurrenceService {

  constructor() {
    moment.locale('fr');
  }

  public findRecurrenceEventsDate(recurrence: RecurrenceRendezVous, model: 'day' | 'week') {
    const initialDateStart = recurrence.dateDebutInitiale;
    const initialDateEnd = recurrence.dateFinInitiale;
    recurrence.dateDebutInitiale = moment(recurrence.dateDebutInitiale).add(recurrence.delais, recurrence.uniteDeTemps).toDate();
    recurrence.dateFinInitiale = moment(recurrence.dateFinInitiale).add(recurrence.delais, recurrence.uniteDeTemps).toDate();

    let dateArr: Array<{ dateStart: Date, dateEnd: Date }> = [];
    const differenceStartEnd = Math.abs(moment(initialDateStart).diff(moment(initialDateEnd), 'minute'));
    const offSet = recurrence.delais;

    if (recurrence.finRecurrence.type === 'date') {
      let dateEnd = moment(recurrence.finRecurrence.date);

      if (recurrence.uniteDeTemps === 'week') {
        let dateStartTmp = moment(recurrence.dateDebutInitiale).clone();
        while (dateStartTmp.isBefore(dateEnd)) {
          recurrence.dateDebutInitiale = dateStartTmp.toDate();
          const tmp = this.__findRecurrenceEventDateWeek(recurrence, initialDateStart, differenceStartEnd, model);
          for (const t of tmp) {
            dateArr.push(t);
          }
          dateStartTmp.add(offSet, 'week');
        }
      }

      if (recurrence.uniteDeTemps === 'month') {
        let dateStartTmp = moment(recurrence.dateDebutInitiale).clone();
        const dayInMonth = dateStartTmp.clone().date();
        let dayNameOfMonth = '';

        while (dateStartTmp.isBefore(dateEnd)) {
          recurrence.dateDebutInitiale = dateStartTmp.toDate();
          const tmp = this.__findRecurrenceEventDateMonth(recurrence, initialDateStart, Math.abs(moment(initialDateStart).diff(initialDateEnd, 'minute')), model);
          if (tmp) {
            dateArr.push(tmp);
          }

          dateStartTmp.date(dayInMonth).add(offSet, 'month');
        }
      }

      if (recurrence.uniteDeTemps === 'year') {
        let dateStartTmp = moment(recurrence.dateDebutInitiale).clone();

        while (dateStartTmp.isBefore(dateEnd)) {
          recurrence.dateDebutInitiale = dateStartTmp.toDate();
          const tmp = this.__findRecurrenceEventDateYear(recurrence, initialDateStart, differenceStartEnd, model);
          if (tmp) {
            dateArr.push(tmp);
          }

          dateStartTmp.add(offSet, 'year').hour(moment(recurrence.dateDebutInitiale).hour()).minute(moment(recurrence.dateDebutInitiale).minute());
        }
      }
    } else if (recurrence.finRecurrence.type === 'ocurrenceNumber') {
      if (recurrence.uniteDeTemps === 'week') {
        let dateStartTmp = moment(recurrence.dateDebutInitiale).clone();
        for (let i = 0; i < (recurrence.finRecurrence.nombreOccurrence as number); i++) {
          recurrence.dateDebutInitiale = dateStartTmp.toDate();
          const tmp = this.__findRecurrenceEventDateWeek(recurrence, initialDateStart, differenceStartEnd, model);
          for (const t of tmp) {
            dateArr.push(t);
          }
          dateStartTmp.add(offSet, 'week');
        }
      }

      if (recurrence.uniteDeTemps === 'month') {
        let dateStartTmp = moment(recurrence.dateDebutInitiale).clone();
        const dayInMonth = dateStartTmp.clone().date();
        let dayNameOfMonth = '';

        for (let i = 0; i < (recurrence.finRecurrence.nombreOccurrence as number); i++) {
          recurrence.dateDebutInitiale = dateStartTmp.toDate();
          const tmp = this.__findRecurrenceEventDateMonth(recurrence, initialDateStart, Math.abs(moment(initialDateStart).diff(initialDateEnd, 'minute')), model);
          if (tmp) {
            dateArr.push(tmp);
          }

          dateStartTmp.date(dayInMonth).add(offSet, 'month');
        }
      }

      if (recurrence.uniteDeTemps === 'year') {
        let dateStartTmp = moment(recurrence.dateDebutInitiale).clone();

        for (let i = 0; i < (recurrence.finRecurrence.nombreOccurrence as number); i++) {
          recurrence.dateDebutInitiale = dateStartTmp.toDate();
          const tmp = this.__findRecurrenceEventDateYear(recurrence, initialDateStart, differenceStartEnd, model);
          if (tmp) {
            dateArr.push(tmp);
          }

          dateStartTmp.add(offSet, 'year').hour(moment(recurrence.dateDebutInitiale).hour()).minute(moment(recurrence.dateDebutInitiale).minute());
        }
      }
    }

    return dateArr;
  }

  private __findRecurrenceEventDateWeek(recurrence: RecurrenceRendezVous, initialDateStart: Date, differenceStartEnd: number, model: 'day' | 'week'): Array<{ dateStart: Date, dateEnd: Date }> {
    const dateArr: Array<{ dateStart: Date, dateEnd: Date }> = [];
    const dateStartMoment = moment(recurrence.dateDebutInitiale);

    if (model === 'day') {
      if ((recurrence.finRecurrence.type === 'date' && dateStartMoment.isBefore(recurrence.finRecurrence.date))
        || recurrence.finRecurrence.type === 'ocurrenceNumber') {
        dateArr.push({
          dateStart: dateStartMoment.toDate(),
          dateEnd: dateStartMoment.add(differenceStartEnd, 'minute').toDate()
        });
      }
    } else if (model === 'week') {
      dateArr.push({
        dateStart: dateStartMoment.day(moment(initialDateStart).day()).toDate(),
        dateEnd: dateStartMoment.day(moment(initialDateStart).day()).add(differenceStartEnd, 'minute').toDate()
      });
    }

    return dateArr;
  }

  private __findRecurrenceEventDateYear(recurrence: RecurrenceRendezVous, initialDateStart: Date, differenceStartEnd: number, model: 'day' | 'week'): { dateStart: Date, dateEnd: Date } | undefined {
    if (model === 'day') {
      return {
        dateStart: recurrence.dateDebutInitiale,
        dateEnd: moment(recurrence.dateDebutInitiale).add(differenceStartEnd, 'minute').toDate()
      };
    } else if (model === 'week') {
      const start = moment(recurrence.dateDebutInitiale).week(moment(initialDateStart).week()).day(moment(initialDateStart).day()).toDate();
      return {
        dateStart: start,
        dateEnd: moment(start).add(differenceStartEnd, 'minute').toDate()
      };
    }
  }

  private __findRecurrenceEventDateMonth(recurrence: RecurrenceRendezVous, initialDateStart: Date, startEndDiff: number, model: 'day' | 'week'): { dateStart: Date, dateEnd: Date } | undefined {
    const getWeekPositionInMonth = (date: Date | moment.Moment) => {
      return Math.ceil(moment(date).date() / 7)
    }

    const getDayPositionInMonth = (date: Date): number => {
      var dateMoment = moment(date);
      var dateClone = dateMoment.clone();
      let i = 0;

      for (i; moment(dateMoment).startOf('month').isSameOrBefore(dateClone); ++i) {
        dateClone.subtract(1, 'week');
      }
      return i;
    }

    const findDayInMonth = (date: Date, positionInMonth: number, positionInWeek: number) => {
      const dateMoment = moment(date).startOf('month');
      let doContinue = true;
      let rtd: Date;

      while (getDayPositionInMonth(dateMoment.toDate()) !== positionInMonth) {
        dateMoment.add(1, 'week');
      }

      while (doContinue) {
        if (dateMoment.day() === positionInWeek) {
          rtd = dateMoment.toDate();
          doContinue = false;
          break;
        } else {
          dateMoment.add(1, 'day');
        }
      }

      return moment(rtd)
        .hour(moment(date).hour())
        .minute(moment(date).minute())
        .second(0)
        .millisecond(0)
        .toDate();
    }

    const findFirstMondayOfMonth = (date: Date) => {
      const monthMoment = moment(date).startOf('month');
      const weekMonday = moment(date).startOf('week')
      while (monthMoment.day() !== weekMonday.day()) {
        monthMoment.add(1, 'day');
      }

      return monthMoment;
    }

    // Si modèle jour on renvoit le Xème jour du mois
    if (model === 'day') {
      const dayPositionInMonth = getDayPositionInMonth(initialDateStart);
      const dayPositionInWeek = moment(initialDateStart).day();
      const dayInMonth = findDayInMonth(recurrence.dateDebutInitiale, dayPositionInMonth, dayPositionInWeek);

      return {
        dateStart: dayInMonth,
        dateEnd: moment(dayInMonth).add(startEndDiff, 'minute').toDate()
      };
    } else if (model == 'week') {
      // Si modèle semaine on renvoit la Xème semaine du mois
      const firstMondayOfInitialMonth = findFirstMondayOfMonth(initialDateStart);
      const numWeek = moment(initialDateStart).startOf('week').diff(firstMondayOfInitialMonth, 'week');

      const firstMondayOfEventMonth = findFirstMondayOfMonth(recurrence.dateDebutInitiale);
      firstMondayOfEventMonth.add(numWeek, 'week');

      const start = moment(recurrence.dateDebutInitiale).date(firstMondayOfEventMonth.date()).add(moment(initialDateStart).day() - 1, 'day');
      // const start = firstMondayOfInitialMonth;
      return {
        dateStart: start.toDate(),
        dateEnd: start.add(startEndDiff, 'minute').toDate()
      };
    }

  }
}